import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "px-6 py-2"
};
const _hoisted_2 = {
  class: "flex w-full"
};
const _hoisted_3 = {
  class: "w-6/12"
};
const _hoisted_4 = {
  class: "table w-full",
  id: "task-table"
};
const _hoisted_5 = {
  class: "truncate max-w-xs"
};
const _hoisted_6 = {
  class: "row"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "w-4/12 px-8"
};
const _hoisted_10 = {
  class: "flex flex-col"
};
const _hoisted_11 = {
  style: {
    "color": "#777",
    "font-size": "11px",
    "font-weight": "bold",
    "line-height": "20px",
    "padding": "3px 5px",
    "text-shadow": "0 1px 0 rgba(255, 255, 255, 0.5)",
    "text-transform": "uppercase"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_main_header = _resolveComponent("main-header");
  const _component_settings_save_bar = _resolveComponent("settings-save-bar");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_main_header, {
    content: "Snippets and Short Codes"
  }), _createElementVNode("form", null, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("table", _hoisted_4, [_cache[6] || (_cache[6] = _createElementVNode("colgroup", null, [_createElementVNode("col", {
    width: "75%"
  }), _createElementVNode("col", {
    width: "15%"
  }), _createElementVNode("col", {
    width: "10%"
  })], -1)), _cache[7] || (_cache[7] = _createElementVNode("thead", null, [_createElementVNode("tr", null, [_createElementVNode("th", null, "Snippet"), _createElementVNode("th", null, "Short Code"), _createElementVNode("th")])], -1)), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.tasks, t => {
    return _openBlock(), _createElementBlock("tr", {
      key: t.id,
      class: _normalizeClass({
        'bg-gray-300': t.isEditing
      })
    }, [_createElementVNode("td", _hoisted_5, _toDisplayString(t.label), 1), _createElementVNode("td", null, _toDisplayString(t.shortCode), 1), _createElementVNode("td", _hoisted_6, [_createElementVNode("a", {
      href: "",
      onClick: _withModifiers($event => $options.setCurrentTask(t), ["prevent"]),
      class: "pull-left span1"
    }, [...(_cache[4] || (_cache[4] = [_createElementVNode("span", {
      class: "fa fa-fw fa-edit fa-lg"
    }, null, -1)]))], 8, _hoisted_7), _createElementVNode("a", {
      href: "",
      onClick: _withModifiers($event => $options.removeTask(t), ["prevent"]),
      class: "pull-right span1 mr-4"
    }, [...(_cache[5] || (_cache[5] = [_createElementVNode("span", {
      class: "fa fa-fw fa-trash-o fa-lg"
    }, null, -1)]))], 8, _hoisted_8)])], 2);
  }), 128))])])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("fieldset", _hoisted_10, [_createElementVNode("label", _hoisted_11, _toDisplayString($options.formActionHeader), 1), _withDirectives(_createElementVNode("textarea", {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.currentTask.label = $event),
    class: "border-radius-none input-xlarge",
    placeholder: "Snippet (Required)",
    style: {
      "border": "1px solid #ccc"
    }
  }, null, 512), [[_vModelText, $data.currentTask.label]]), _withDirectives(_createElementVNode("input", {
    type: "text",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.currentTask.shortCode = $event),
    class: "border-radius-none input-xlarge",
    placeholder: "Short Code (Optional)"
  }, null, 512), [[_vModelText, $data.currentTask.shortCode]])])])]), _cache[8] || (_cache[8] = _createElementVNode("div", {
    class: "w-6/12"
  }, [_createElementVNode("p", null, "Text snippets are frequently used phrases that speed up creating time entries."), _createElementVNode("p", null, "Note that snippets are shared between all members of your firm.")], -1)), _createVNode(_component_settings_save_bar, {
    somethingChanged: $options.showButtonGroup,
    saving: $data.isProcessing,
    unsaved: $data.unsaved,
    disabled: $options.isSubmitButtonDisabled,
    onUpdate: _cache[2] || (_cache[2] = $event => $options.upsertTask()),
    onCancel: _cache[3] || (_cache[3] = $event => $options.setCurrentTask(null))
  }, null, 8, ["somethingChanged", "saving", "unsaved", "disabled"])])]);
}